import { View, Text, Image } from "react-native";
import React, { useState, useEffect } from "react";
import { danger, femaleColor, gray, maleColor, primary } from "../../colors";
import MyText from "../custom/MyText";
import { doctorAvatar } from "../../imports";
import detailConsultationUser from "../../api/consultation/detailConsultationUser";
import childConsultationStatus from "../../api/consultation/childConsultationStatus";
import { useNavigation } from "@react-navigation/native";
import MyButton from "../custom/MyButton";
import closeConsultation from "../../api/consultation/closeConsultation";

export default function DoctorChatDetail({
  gender,
  image,
  children,
  setId,
  id,
  setShowRating,
}) {
  const navigation = useNavigation();
  const [doctorDetails, setDoctorDetails] = useState({});
  const [haveChat, setHaveChat] = useState(true);

  useEffect(() => {
    if (children.id !== undefined) {
      detailConsultationUser(id)
        .then(({ data }) => {
          if (data.status === 200) {
            setDoctorDetails(data.data.doctor);
          }
        })
        .catch((err) => {});
    }
  }, [children]);
  const closeChat = () => {
    closeConsultation(id).then(({ data }) => {
   
      if (data.status === 200) {
        setShowRating(true);
      }
    });
  };
  //console.log(doctorDetails);
  return haveChat ? (
    <View
      style={{
        width: "92%",
        marginHorizontal: 5,
        borderRadius: 15,
        borderColor: gender === "female" ? femaleColor : maleColor,
        borderWidth: 1,
        padding: 10,
        backgroundColor: "#F9F9F9",
        marginTop: -10,

        alignItems: "center",
      }}
    >
      <View style={{ width: "100%", flexDirection: "row" }}>
        <View>
          <MyText style={{ fontSize: 18, fontWeight: "bold" }}>
            {`${doctorDetails.name || ""} ${doctorDetails.lastName || ""}`}
          </MyText>
          <MyText style={{ color: gray, fontSize: 14 }}>{`${
            doctorDetails.decExpertise || ""
          }`}</MyText>
        </View>
        <View style={{ flex: 1 }}></View>
        <View
          style={{
            width: 70,
            height: 70,
            borderWidth: 1,
            borderColor: primary,
            borderRadius: 100,
            overflow: "hidden",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Image
            source={{ uri: doctorDetails.picUrl }}
            defaultSource={doctorAvatar}
            style={{ width: 60, height: 60 }}
            resizeMode="contain"
          />
        </View>
      </View>
      <View style={{ width: "96%", flexDirection: "row" }}>
        <MyButton
          text={"بستن مشاوره"}
          style={{ backgroundColor: danger }}
          textStyle={{ fontSize: 13 }}
          onPress={closeChat}
        />
      </View>
    </View>
  ) : (
    <View
      style={{
        width: "92%",
        marginHorizontal: 5,
        borderRadius: 15,
        borderColor: gender === "female" ? femaleColor : maleColor,
        borderWidth: 1,
        padding: 10,
        backgroundColor: "#F9F9F9",
        marginTop: -10,
        flexDirection: "row",
        alignItems: "center",
      }}
    ></View>
  );
}
